
import CheckboxField from '@/components/processing_steps/commons/fields/CheckboxField.vue'
import FormContainer from '@/components/processing_steps/commons/forms/FormContainer.vue'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { IPSEditFundingScope, ISummaryItem } from '@/types/processingSteps'
import SummaryItems from '../../commons/forms/SummaryItems.vue'
import SingleSelectField from '../../commons/fields/SingleSelectField.vue'

@Component({
  components: {
    FormContainer,
    CheckboxField,
    SummaryItems,
    SingleSelectField
  }
})
export default class AdminCompletitionForm extends Vue {
  @Prop() isComplete!: boolean
  @Prop() summaryItems!: ISummaryItem[]
  @Prop() fundingScope!: IPSEditFundingScope | null

  get statusOptions() {
    return [
      { value: 1, text: this.$gettext('In Progress') },
      { value: 2, text: this.$gettext('Complete') },
      { value: 3, text: this.$gettext('Archived') },
      { value: 4, text: this.$gettext('Paused') }
    ]
  }

  get isPublicHintHtml() {
    return this.$gettext(
      "Funding scopes that are not public can't be assigned to projects."
    )
  }
}
